import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const contactDetails = [
  {
    title: "Phone Support",
    value: "+971 5444 111 79",
    sub: "Available for consultation and support",
    icon: "Phone",
    accent: true
  },
  {
    title: "Email Contact",
    value: "info@vastech.ae",
    sub: "Response within 24 hours",
    icon: "Mail",
    accent: false
  },
  {
    title: "Office Location",
    value: "Abu Dhabi Business Center, UAE",
    sub: "Mon-Fri: 8:00 AM - 6:00 PM",
    icon: "MapPin",
    accent: false
  }
];

const ContactInfo = () => {
  return (
    <div className="space-y-12">
      <motion.div
        initial={{ opacity: 0, x: -30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <h2 className="text-sm font-bold uppercase tracking-[0.4em] text-[#91756A] mb-6 flex items-center">
          <span className="w-8 h-px bg-[#91756A] mr-4"></span> Contact Information
        </h2>
        <h3 className="text-4xl font-bold text-[#4D4C4A] leading-[1.1] mb-8 italic tracking-tighter">
          Reach out to our <br />
          <span className="text-[#91756A]">Expert</span> Team.
        </h3>
        <p className="text-slate-500 text-lg leading-relaxed">
          Whether you need an emergency repair, a new installation, or a maintenance contract, 
          we are here to provide precision-engineered support.
        </p>
      </motion.div>

      <div className="grid gap-6">
        {contactDetails.map((detail, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1, duration: 0.6 }}
            className="flex items-start gap-6 p-8 border border-slate-100 bg-slate-50 hover:bg-white hover:shadow-xl transition-all duration-500 group"
          >
            <div className={`w-12 h-12 flex items-center justify-center shrink-0 rounded-sm ${detail.accent ? 'bg-[#91756A] text-white' : 'bg-[#4D4C4A] text-[#91756A]'}`}>
              <Icon name={detail.icon} size={20} />
            </div>
            <div>
              <h4 className="text-xs font-bold uppercase tracking-widest text-slate-400 mb-1">{detail.title}</h4>
              <p className={`text-xl font-bold italic tracking-tight ${detail.accent ? 'text-[#91756A]' : 'text-[#4D4C4A]'}`}>
                {detail.value}
              </p>
              <p className="text-sm text-slate-400 mt-1 font-medium">{detail.sub}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ContactInfo;